import { render, staticRenderFns } from "./TrendingTopicsContainer.vue?vue&type=template&id=cd3d4c52&scoped=true&"
import script from "./TrendingTopicsContainer.vue?vue&type=script&lang=js&"
export * from "./TrendingTopicsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TrendingTopicsContainer.vue?vue&type=style&index=0&id=cd3d4c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3d4c52",
  null
  
)

export default component.exports